import styled from "styled-components";

const StyledTitle = styled.div`
  word-break: break-all;
`;
export default StyledTitle;
